import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { isTOSCheckboxShownSelector } from '../../../../../customer/redux/checkout/checkout.selectors';
import { PaymentInformation as Component } from './payment-information';
const selector = createStructuredSelector({
  isTOSCheckboxShown: isTOSCheckboxShownSelector
});
const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);
export const PaymentInformation = connect(selector, mapDispatchToProps)(Component);